import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  CustomForm,
  CustomFormItem,
  CustomSpinSelect,
  OptionSpin,
  Text,
  CustomCheckbox,
  useText,
} from '@src/components';
import { Form, Row, Col, Button } from 'antd';
import { UpCircleOutlined, DownCircleOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import {
  getVehicleFuelTypes,
  getVehicleDepartments,
  getVehicleCostCenter,
  getVehicleTypes,
  getVehicleAttributes,
  getVehicleLAddressGetList,
} from '@src/store/slice/addNewCarStore/addCarPlateDetailSlice';
import { DeviceType } from '@src/store/enums';
import '@src/styles/addNewCar/addCarSelectInformation.scss';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { setShowLoader } from '@src/store/slice/appSettingsSlice';

const AddCarSelectInformation = ({
  index,
  vehicleDetails,
  onChange,
  setVehicleDetails,
  plateFields,
  setCopyDetailsChecked,
  vehicleDetailsState,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const {
    vehicleFuelTypes = [],
    vehicleDepartments = [],
    vehicleCostCenters = [],
    vehicleTypes = [],
    vehicleAttributes = [],
    vehicleLAddressGetList = [],
  } = useSelector((state) => state.addCarPlateDetail);
  const { isAdmin } = useSelector((state) => state.auth);
  const { selectedUserId } = useSelector((state) => state.user);
  const { selectVehicleDeviceTypeList } = useSelector((state) => state?.addCarType);
  const [isVehicleInfoEnabled, setIsVehicleInfoEnabled] = useState(true);
  const [checkboxState, setCheckboxState] = useState(false);
  const isMobil = useMediaQuery({ query: '(max-width: 768px)' });
  const { showLoader } = useSelector((state) => state?.appSettings);
  const [flagDepartments, setFlagDepartments] = useState(false);
  const [flagCostCenter, setFlagCostCenter] = useState(false);
  const [flagAddressList, setFlagAddressList] = useState(false);

  const vehicleType = useText('vehicleType');
  const vehicleQualification = useText('vehicleQualification');
  const deliveryAddress2Text = useText('deliveryAddress2');
  const fuelType2 = useText('fuelType2');
  const department = useText('department');
  const costCenter = useText('costCenter');
  
  useEffect(async () => {
    if (
      showLoader &&
      vehicleAttributes?.length > 0 &&
      vehicleFuelTypes?.length > 0 &&
      vehicleTypes?.length > 0 &&
      ((vehicleLAddressGetList?.length > 0 &&
        vehicleCostCenters?.length > 0 &&
        vehicleDepartments?.length > 0) ||
        (flagDepartments && flagCostCenter)) &&
      flagAddressList
    ) {
      await dispatch(setShowLoader(false));
    }
  }, [
    showLoader,
    vehicleLAddressGetList,
    vehicleAttributes,
    vehicleDepartments,
    vehicleFuelTypes,
    vehicleCostCenters,
    vehicleTypes,
    flagAddressList,
    flagDepartments,
    flagCostCenter,
    dispatch,
  ]);

  useEffect(async () => {
    if (
      showLoader &&
      vehicleAttributes?.length > 0 &&
      vehicleFuelTypes?.length > 0 &&
      vehicleTypes?.length > 0 &&
      ((vehicleLAddressGetList?.length > 0 &&
        vehicleCostCenters?.length > 0 &&
        vehicleDepartments?.length > 0) ||
        (flagDepartments && flagCostCenter)) &&
      flagAddressList
    ) {
      await dispatch(setShowLoader(false));
    }
  }, [
    showLoader,
    vehicleLAddressGetList,
    vehicleAttributes,
    vehicleDepartments,
    vehicleFuelTypes,
    vehicleCostCenters,
    vehicleTypes,
    flagAddressList,
    flagDepartments,
    flagCostCenter,
    dispatch,
  ]);

  const fetchData = async () => {
    await dispatch(setShowLoader(true));
    if (isAdmin && selectedUserId) {
      dispatch(getVehicleLAddressGetList({ customerId: selectedUserId, vehicleDetailsState }));
    } else {
      dispatch(getVehicleLAddressGetList({ vehicleDetailsState }));
    }

};

  useEffect(() => {
    if (vehicleLAddressGetList?.length === 0 && !flagAddressList) {
      setFlagAddressList(true);
      fetchData();
    }
  }, [dispatch, vehicleLAddressGetList.length, vehicleDetailsState]);

  const fetchVehicleAttributes = async () => {
    await dispatch(getVehicleAttributes());
  };

  useEffect(async () => {
    if (vehicleAttributes?.length === 0) {
      await dispatch(setShowLoader(true));
      await fetchVehicleAttributes();
    }
  }, [vehicleAttributes, dispatch]);

  const fetchVehicleFuelTypes = async () => {
    await dispatch(getVehicleFuelTypes());
  };

  useEffect(async () => {
    if (vehicleFuelTypes?.length === 0) {
      await dispatch(setShowLoader(true));
      await fetchVehicleFuelTypes();
    }
  }, [vehicleFuelTypes, dispatch]);

  const fetchVehicleTypes = async () => {
    await dispatch(getVehicleTypes());
  };

  useEffect(async () => {
    if (vehicleTypes?.length === 0) {
      await dispatch(setShowLoader(true));
      await fetchVehicleTypes();
    }
  }, [vehicleTypes, dispatch]);

  const fetchCostCenters = async () => {
    if (isAdmin && selectedUserId) {
      await dispatch(getVehicleCostCenter({ vouId: 4, customerId: selectedUserId }));
    } else {
      await dispatch(getVehicleCostCenter({ vouId: 4 }));
    }
  };

  useEffect(async () => {
    if (vehicleCostCenters?.length === 0 && !flagCostCenter) {
      await dispatch(setShowLoader(true));
      await fetchCostCenters();
      setFlagCostCenter(true);
    }
  }, [vehicleCostCenters, dispatch]);

  const fetchDepartments = async () => {
    if (isAdmin && selectedUserId) {
      await dispatch(getVehicleDepartments({ customerId: selectedUserId, vouId: 4 }));
    } else {
      await dispatch(getVehicleDepartments({ vouId: 4 }));
    }
  };

  useEffect(async () => {
    if (vehicleDepartments?.length === 0 && !flagDepartments) {
      await dispatch(setShowLoader(true));
      await fetchDepartments();
      setFlagDepartments(true);
    }
  }, [vehicleDepartments, dispatch]);

  useEffect(() => {
    form.setFieldsValue({ ...vehicleDetails, copyDetails: checkboxState });
  }, [vehicleDetails, form, checkboxState]);

  const handleCheckboxChange = () => {
    setIsVehicleInfoEnabled(!isVehicleInfoEnabled);
  };

  const isPreviousFormValid = () => {
    if (index === 0) return false; // First form cannot copy from previous
    const previousDetails = vehicleDetailsState[index - 1];
    if (!previousDetails) return false;
    let requiredFields = ['vehicleTypeId', 'attributeNameId', 'fuelTypeId']; // 'departmanId', 'costCenterId',
    if (selectVehicleDeviceTypeList?.deviceTypeId === DeviceType.TYPE_3) {
      requiredFields.push('addressGetListId');
    }
    return requiredFields.every((field) => previousDetails[field]);
  };

  const handleCopyDetailsChange = (e) => {
    const checked = e.target.checked;
    const previousIndex = index - 1;

    setCheckboxState(checked);

    setCopyDetailsChecked((prevChecked) => ({
      ...prevChecked,
      [index]: checked,
    }));

    if (checked && previousIndex >= 0 && plateFields[previousIndex]) {
      const previousDetails = vehicleDetailsState[previousIndex] || {};
      setVehicleDetails(previousDetails);
      form.setFieldsValue({ ...previousDetails, copyDetails: checked });
    } else {
      //setVehicleDetails({});
      //form.resetFields();
      console.log('Reset fields and cleared details');
    }
  };

  const handleValuesChange = (changedValues, allValues) => {
    Object.keys(changedValues).forEach((key) => {
      if (key === 'vehicleTypeId') {
        const selectedVehicleType = vehicleTypes.find(
          (vehicle) => vehicle.vehicleTypeId === changedValues[key],
        );
        allValues.vehicleType = {
          id: selectedVehicleType?.vehicleTypeId,
          name: selectedVehicleType?.vehicleTypeName,
        };
      } else if (key === 'attributeNameId') {
        const selectedAttribute = vehicleAttributes.find(
          (attribute) => attribute.vehicleAttributeId === changedValues[key],
        );
        allValues.attribute = {
          id: selectedAttribute?.vehicleAttributeId,
          name: selectedAttribute?.vehicleAttributeName,
        };
      } else if (key === 'costCenterId') {
        const selectedCostCenter = vehicleCostCenters.find(
          (costCenter) => costCenter.costCenterId === changedValues[key],
        );
        allValues.costCenter = {
          id: selectedCostCenter?.costCenterId,
          name: selectedCostCenter?.costCenterLabel,
        };
      } else if (key === 'fuelTypeId') {
        const selectedVehicleFuelType = vehicleFuelTypes.find(
          (vehicleFuelType) => vehicleFuelType.fuelTypeId === changedValues[key],
        );
        allValues.vehicleFuelType = {
          id: selectedVehicleFuelType?.fuelTypeId,
          name: selectedVehicleFuelType?.fuelTypeLabel,
        };
      } else if (key === 'departmanId') {
        const selectedDepartment = vehicleDepartments.find(
          (department) => department.id === changedValues[key],
        );
        allValues.department = {
          id: selectedDepartment?.vehicleDepartmentId,
          name: selectedDepartment?.departmentLabel,
        };
      } else if (key === 'addressGetListId') {
        const selectedAddress = vehicleLAddressGetList.find(
          (address) => address.id === changedValues[key],
        );
        allValues.address = {
          id: selectedAddress?.id,
          name: selectedAddress?.name,
        };
      }
    });
    const newPlateForm = { ...vehicleDetails, ...allValues };
    if (
      newPlateForm?.costCenterId !== vehicleDetailsState[index - 1]?.costCenterId ||
      newPlateForm?.addressGetListId !== vehicleDetailsState[index - 1]?.addressGetListId ||
      newPlateForm?.attributeNameId !== vehicleDetailsState[index - 1]?.attributeNameId ||
      newPlateForm?.fuelTypeId !== vehicleDetailsState[index - 1]?.fuelTypeId ||
      newPlateForm?.vehicleFuelType?.id !== vehicleDetailsState[index - 1]?.vehicleFuelType?.id ||
      newPlateForm?.vehicleTypeId !== vehicleDetailsState[index - 1]?.vehicleTypeId
    ) {
      setCheckboxState(false);
    } else {
      setCheckboxState(true);
    }
    setVehicleDetails({ ...vehicleDetails, ...allValues });

    if (onChange) {
      onChange({ ...vehicleDetails, ...allValues });
    }
  };

  return (
    <div className="add-car-select-information">
      <Row
        justify={'space-between'}
        align="middle"
        className="header-row-title-2"
        onClick={handleCheckboxChange}
      >
        <span>
          <Text t="carInformation" />
        </span>
        <Button
          type="text"
          icon={
            isVehicleInfoEnabled ? (
              <UpCircleOutlined style={{ color: '#1d2228', fontSize: '24px' }} />
            ) : (
              <DownCircleOutlined style={{ color: '#1d2228', fontSize: '24px' }} />
            )
          }
          className="toggle-button"
        />
      </Row>
      {isVehicleInfoEnabled && (
        <CustomForm
          name={`vehicleDetails-${index}`}
          className="filter-form"
          autoComplete="off"
          initialValues={{}}
          layout={'vertical'}
          form={form}
          onValuesChange={handleValuesChange}
        >
          {index > 0 && (
            <div className="form-item">
              <CustomFormItem label={false} name="copyDetails" valuePropName="checked">
                <CustomCheckbox
                  className={!isPreviousFormValid() ? 'disabled-checkbox' : ''}
                  checked={checkboxState}
                  onChange={handleCopyDetailsChange}
                >
                  <span className="address-form-item">
                    <Text t="applyTheSelectionsOfTheVehicleAboveTo" />
                  </span>
                </CustomCheckbox>
              </CustomFormItem>
            </div>
          )}

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="form-item">
            <Col span={isMobil ? 24 : 8}>
              <CustomFormItem
                label={
                  <span>
                    <Text t="vehicleType" /> <span style={{ color: 'red' }}>*</span>
                  </span>
                }
                name="vehicleTypeId"
                rules={[{ required: true, message: <Text t="requiredField2" /> }]}
              >
                <CustomSpinSelect
                  id="add-car-plate-detail-vehicleTypeId-select"
                  placeholder={vehicleType}
                  disabled={vehicleTypes.length === 0}
                  loading={vehicleTypes.length === 0}
                  height={36}
                >
                  {vehicleTypes?.map((vehicle) => (
                    <OptionSpin
                      id={`add-car-plate-detail-vehicleTypeId-${vehicle?.vehicleTypeName}-option`}
                      key={vehicle?.vehicleTypeId}
                      value={vehicle?.vehicleTypeId}
                    >
                      {vehicle?.vehicleTypeName}
                    </OptionSpin>
                  ))}
                </CustomSpinSelect>
              </CustomFormItem>
            </Col>

            <Col span={isMobil ? 24 : 8}>
              <CustomFormItem
                label={
                  <span>
                    <Text t="vehicleQualification" /> <span style={{ color: 'red' }}>*</span>
                  </span>
                }
                rules={[{ required: true, message: <Text t="requiredField2" /> }]}
                name="attributeNameId"
                className={'delivery-address-county-form-item'}
              >
                <CustomSpinSelect
                  id="add-car-plate-detail-attributeNameId-select"
                  placeholder={vehicleQualification}
                  disabled={vehicleAttributes.length === 0}
                  loading={vehicleAttributes.length === 0}
                  height={36}
                >
                  {vehicleAttributes?.map((vehicle) => (
                    <OptionSpin
                      id={`add-car-plate-detail-attributeNameId-${vehicle?.vehicleAttributeName}-option`}
                      key={vehicle?.vehicleAttributeId}
                      value={vehicle?.vehicleAttributeId}
                    >
                      {vehicle?.vehicleAttributeName}
                    </OptionSpin>
                  ))}
                </CustomSpinSelect>
              </CustomFormItem>
            </Col>

            <Col span={isMobil ? 24 : 8}>
              <CustomFormItem
                label={
                  <span>
                    <Text t="fuelType2" /> <span style={{ color: 'red' }}>*</span>
                  </span>
                }
                rules={[{ required: true, message: <Text t="requiredField2" /> }]}
                name="fuelTypeId"
                className={'delivery-address-add-form-item'}
              >
                <CustomSpinSelect
                  id="add-car-plate-detail-fuelTypeId-select"
                  placeholder={fuelType2}
                  disabled={vehicleFuelTypes.length === 0}
                  loading={vehicleFuelTypes.length === 0}
                  height={36}
                >
                  {vehicleFuelTypes?.map((vehicle) => (
                    <OptionSpin
                      id={`add-car-plate-detail-fuelTypeId-${vehicle?.fuelTypeLabel}-option`}
                      key={vehicle?.fuelTypeId}
                      value={vehicle?.fuelTypeId}
                    >
                      {vehicle?.fuelTypeLabel}
                    </OptionSpin>
                  ))}
                </CustomSpinSelect>
              </CustomFormItem>
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="form-item">
            <Col span={isMobil ? 24 : 8}>
              <CustomFormItem
                label={
                  <span>
                    {deliveryAddress2Text}{' '}
                    {selectVehicleDeviceTypeList?.deviceTypeId === DeviceType.TYPE_3 ? (
                      <span style={{ color: 'red' }}>*</span>
                    ) : (
                      ''
                    )}
                  </span>
                }
                name="addressGetListId"
                className={'delivery-address-county-form-item'}
              >
                <CustomSpinSelect
                  id="add-car-plate-detail-addressGetListId-select"
                  placeholder={deliveryAddress2Text}
                  disabled={vehicleLAddressGetList.length === 0}
                  loading={vehicleLAddressGetList.length === 0}
                  height={36}
                >
                  {vehicleLAddressGetList?.map((vehicle) => (
                    <OptionSpin
                      id={`add-car-plate-detail-addressGetListId-${vehicle?.name}-option`}
                      key={vehicle?.id}
                      value={vehicle?.id}
                    >
                      {vehicle?.name}
                    </OptionSpin>
                  ))}
                </CustomSpinSelect>
              </CustomFormItem>
            </Col>
            {vehicleDepartments?.length ? (
              <Col span={isMobil ? 24 : 8}>
                <CustomFormItem
                  label={<Text t="department" />}
                  name="departmanId"
                  className={'delivery-address-county-form-item'}
                >
                  <CustomSpinSelect
                    id="add-car-plate-detail-departmanId-select"
                    placeholder={department}
                    disabled={vehicleDepartments.length === 0}
                    loading={vehicleDepartments.length === 0}
                    height={36}
                  >
                    {vehicleDepartments?.map((vehicle) => (
                      <OptionSpin
                        id={`add-car-plate-detail-departmanId-${vehicle?.departmentLabel}-option`}
                        key={vehicle?.id}
                        value={vehicle?.id}
                      >
                        {vehicle?.label}
                      </OptionSpin>
                    ))}
                  </CustomSpinSelect>
                </CustomFormItem>
              </Col>
            ) : null}
            {vehicleCostCenters?.length ? (
              <Col span={isMobil ? 24 : 8}>
                <CustomFormItem
                  label={<Text t="costCenter" />}
                  name="costCenterId"
                  className={'delivery-address-county-form-item'}
                >
                  <CustomSpinSelect
                    id="add-car-plate-detail-costCenterId-select"
                    placeholder={costCenter}
                    disabled={vehicleCostCenters.length === 0}
                    loading={vehicleCostCenters.length === 0}
                    height={36}
                  >
                    {vehicleCostCenters?.map((vehicle) => (
                      <OptionSpin
                        id={`add-car-plate-detail-costCenterId-${vehicle?.costCenterLabel}-option`}
                        key={vehicle?.costCenterId}
                        value={vehicle?.costCenterId}
                      >
                        {vehicle?.costCenterLabel}
                      </OptionSpin>
                    ))}
                  </CustomSpinSelect>
                </CustomFormItem>
              </Col>
            ) : null}
          </Row>
        </CustomForm>
      )}
    </div>
  );
};

AddCarSelectInformation.propTypes = {
  index: PropTypes.number.isRequired,
  vehicleDetails: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  setVehicleDetails: PropTypes.func.isRequired,
  plateFields: PropTypes.array.isRequired,
  setCopyDetailsChecked: PropTypes.func.isRequired,
  vehicleDetailsState: PropTypes.array.isRequired,
};

export default AddCarSelectInformation;
